import React, {useState} from 'react';
import moment from 'moment';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../../../_common/components/ButtonAction';
import ModalHeader from '../../../../../_common/components/ModalHeader';
import ModalContainer from '../../../../../_common/components/ModalContainer';
import PopupEditNote from "../PopupEditNote/PopupEditNote";
import ModalButtonsContainer from '../../../../../_common/components/ModalButtonsContainer';
import ButtonDD from "../../../../../_common/components/ButtonDD";
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../../_common/styles/styles';
import styles from '../../styles.module.scss';

const Note = ({
                generalNoteID,
                createDate,
                generalNoteStatus,
                dueDate,
                createUserFirstName,
                createUserLastName,
                responsibleUserFirstName,
                responsibleUserLastName,
                freeText,
                onOpen,
                onEdit,
                onDelete
              }) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {formatMessage} = useIntl();
  const popupMessage = [formatMessage({
    id: 'tasks-message-delete-general-note',
    defaultMessage: 'Delete general note'
  }), `${generalNoteID}?`].join(' ');

  const getDateBadge = (value) => {
    return value && (
      <div className={'badge'} style={{
        padding: '6px 12px',
        borderRadius: '999px',
        background: 'rgba(255,255,255,0.35)',
        border: '1px solid rgba(0,0,0,0.45)'
      }}>
        <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
          {value}
        </div>
      </div>
    );
  };

  const cellsArray = [
    {value: generalNoteID},
    {value: getDateBadge(createDate ? moment(createDate).format('DD-MM-YYYY') : '')},
    {value: generalNoteStatus},
    {value: freeText || ''},
    {value: getDateBadge(dueDate ? moment(dueDate).format('DD-MM-YYYY') : '')},
    {value: [createUserFirstName, createUserLastName].filter(Boolean).join(' ')},
    {value: [responsibleUserFirstName, responsibleUserLastName].filter(Boolean).join(' ')},
  ];

  const mapRows = (item, index) => {
    return (
      <div
        key={index}
        className={styles.cell}
      >
        {item.value}
      </div>
    );
  };

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(generalNoteID);
      handleCloseModal();
    }
  };

  return (
    <div className={styles.row}>
      {cellsArray.map(mapRows)}
      <div className={styles.lastCell}>
        <ButtonDD
          items={[{
            itemContent: (
              <div className="d-flex justify-content-between align-items-center">
                <PopupEditNote
                  generalNoteID={generalNoteID}
                  onEdit={onEdit}
                  onOpen={onOpen}
                />
                <div className={'mx-2'}/>
                <ButtonAction
                  variant={'icon'}
                  iconButtonType={'error'}
                  onClick={handleShowModal}
                  label={
                    <img
                      src={'../../../media/common/Delete_red.svg'}
                      alt="delete" className="w-20px h-20px"
                    />
                  }
                />
                <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
                  <ModalHeader header={popupMessage}/>
                  <ModalButtonsContainer customClassnames={largeButtonsPadding}>
                    <ButtonAction
                      variant={'cancel'}
                      onClick={handleCloseModal}
                      label={formatMessage({id: 'no', defaultMessage: 'No'})}
                      customClassnames={buttonCancel}
                    />
                    <ButtonAction
                      onClick={handleDelete}
                      useIcon={'/media/common/Check-in-circle_white.svg'}
                      label={formatMessage({id: 'yes', defaultMessage: 'Yes'})}
                      customClassnames={buttonSubmit}
                    />
                  </ModalButtonsContainer>
                </ModalContainer>
              </div>
            )
          }
          ]}
        />
      </div>
    </div>
  );
};

export default Note;